var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._b({staticClass:"info-chip d-flex align-center justify-center"},'v-chip',_vm.$attrs,false),[_vm._t("default"),_c('div',{staticClass:"chip-icon",style:(`height: ${_vm.iconSize}px`)},[_vm._t("icon")],2),_c('div',{staticClass:"chip-text mx-2"},[_vm._t("text")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }